// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.main-footer {
    background: #5F2282;
    padding: 15px;
    color: #fff;
    border-top: 1px solid #f0569c;
}`, "",{"version":3,"sources":["webpack://./src/Components/Css/Footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,aAAa;IACb,WAAW;IACX,6BAA6B;AACjC","sourcesContent":[".main-footer {\n    background: #5F2282;\n    padding: 15px;\n    color: #fff;\n    border-top: 1px solid #f0569c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
